import React from 'react';

const SpaceBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Dark space base */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, #000005 0%, #020810 40%, #0a1628 70%, #0d1f3c 100%)'
        }}
      />

      {/* Stars layer 1 - tiny distant stars */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(0.8px 0.8px at 20px 30px, rgba(255,255,255,0.9), transparent),
                            radial-gradient(0.8px 0.8px at 40px 70px, rgba(255,255,255,0.7), transparent),
                            radial-gradient(0.8px 0.8px at 50px 160px, rgba(255,255,255,0.6), transparent),
                            radial-gradient(0.8px 0.8px at 90px 40px, rgba(255,255,255,0.8), transparent),
                            radial-gradient(0.8px 0.8px at 130px 80px, rgba(255,255,255,0.7), transparent),
                            radial-gradient(0.8px 0.8px at 160px 120px, rgba(255,255,255,0.9), transparent),
                            radial-gradient(0.8px 0.8px at 180px 90px, rgba(255,255,255,0.6), transparent),
                            radial-gradient(0.8px 0.8px at 70px 140px, rgba(255,255,255,0.8), transparent)`,
          backgroundSize: '200px 200px'
        }}
      />

      {/* Stars layer 2 - small stars */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(1.2px 1.2px at 150px 150px, rgba(255,255,255,1), transparent),
                            radial-gradient(1.2px 1.2px at 250px 50px, rgba(200,220,255,0.9), transparent),
                            radial-gradient(1.2px 1.2px at 100px 200px, rgba(255,255,255,0.8), transparent),
                            radial-gradient(1.2px 1.2px at 300px 100px, rgba(255,255,255,1), transparent),
                            radial-gradient(1.2px 1.2px at 80px 280px, rgba(220,230,255,0.8), transparent),
                            radial-gradient(1.2px 1.2px at 320px 220px, rgba(255,255,255,0.9), transparent)`,
          backgroundSize: '400px 350px'
        }}
      />

      {/* Stars layer 3 - brighter accent stars */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(2px 2px at 500px 200px, rgba(255,255,255,1), transparent),
                            radial-gradient(2px 2px at 200px 400px, rgba(200,220,255,1), transparent),
                            radial-gradient(1.8px 1.8px at 700px 100px, rgba(255,250,240,0.95), transparent),
                            radial-gradient(2.5px 2.5px at 900px 300px, rgba(255,255,255,1), transparent),
                            radial-gradient(1.5px 1.5px at 350px 500px, rgba(255,255,255,0.9), transparent),
                            radial-gradient(2px 2px at 1100px 150px, rgba(220,230,255,1), transparent)`,
          backgroundSize: '1200px 700px'
        }}
      />

      {/* Earth atmospheric glow - bottom edge */}
      <div
        className="absolute bottom-0 left-0 right-0 h-80"
        style={{
          background: 'linear-gradient(to top, rgba(56, 189, 248, 0.15) 0%, rgba(59, 130, 246, 0.08) 30%, rgba(37, 99, 235, 0.03) 60%, transparent 100%)'
        }}
      />

      {/* Earth glow - bright horizon line */}
      <div
        className="absolute bottom-0 left-0 right-0 h-1"
        style={{
          background: 'linear-gradient(to right, transparent 5%, rgba(125, 211, 252, 0.4) 20%, rgba(56, 189, 248, 0.6) 50%, rgba(125, 211, 252, 0.4) 80%, transparent 95%)',
          boxShadow: '0 0 60px 30px rgba(56, 189, 248, 0.3), 0 0 100px 60px rgba(59, 130, 246, 0.2)'
        }}
      />

      {/* Subtle atmospheric scatter on sides */}
      <div className="absolute bottom-0 left-0 w-1/3 h-64 bg-gradient-to-tr from-cyan-500/10 via-blue-500/5 to-transparent" />
      <div className="absolute bottom-0 right-0 w-1/3 h-64 bg-gradient-to-tl from-cyan-500/10 via-blue-500/5 to-transparent" />
    </div>
  );
};

export default SpaceBackground;
